import React, { Component, useState } from "react";
import "./EsignNewForm.scss";
import {
  AEmailUpdateApi,
  AGetOtpNew,
  ALeadFetchApi,
  AValidateOtpNew,
  CreateUCCRegCode,
} from "../../Services/registration/registrationApiService";
import GlobalStore from "../../store/globalStore";
import {
  emailRegex,
  forbiddenWordsRegex,
  integerExp,
  phoneNo,
} from "../../utils/regex";
import InputField from "../../UI/InputField/InputField";
import { errorCode, errorMsg } from "../../../ErrorCode/ErrorCode";
import {
  SubmitButton,
  TransparentButton,
  Verify,
} from "../../UI/Button/Button";
import RegOtp from "../../Registration/RegOtp/RegOtp";
import { AGetClientDetailsByPan, AGetClientDetailsByPanV1 } from "../../Services/registration/panDobApiService";
import {
  AGetStageCompletionStatus,
  AUpdateStageCompletionStatus,
} from "../../Services/registration/continueApiService";

import gtmService from "../../Services/gtmService";
import cleverTapEvents from "../../../config/cleverTapEvents";
import { ClevertapService } from "../../Services/clevertapService";
import useQuery from "../../../customHooks/useQuery";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import { AgetAMLDetails, AGetRMEsignUrlDetails } from "../../Services/dashboard/eSignApiServices";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import { downloadForm } from "../../POA/Poa";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";
import { containerUrl, gulfCountryCodes, statusUrl } from "../../utils/constants";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Radio from "../../UI/Radio/Radio";
import moment from "moment";
import { ILocalQueryObject } from "../../Registration/PANInfo/PANInfoJoint";
import MobileInput from "../../UI/MobileInput/MobileInput";
export interface ILeadFormFields {
  email: string;
  mobile: string;
}
export interface IEsignProps {
  pan?: string;
  setIsKRA?: Function;
  isKRA?: boolean;
  userId?: string;
  queryParamsId?: string;
}

export interface ICompletionStatus {
  pan: string;
  token: string;
  ApplicatoinId: string;
  leadId: string;
  clientPrimaryDetailId: string;
  AccountCategory?: number;
}
export interface ILeadDetails {
  email?: string;
  mobile?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  pan?: string;
  dob?: string;
  productid?: string;
  categoryid?: string;
  rmid?: string;
  leadid?: string;
  accountCategory?: string;
  isMobileVerified?: boolean;
  isEmailVerified?: boolean;
  isPanVerified?: boolean;
  uccCode?: string;
  countryprefix?: string;
}

interface AccountHolder {
  id: number;
  isPrimary?: boolean;
  name?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  pan?: string;
  dob?: any;
  relation?: string;
  email?: string;
  mobile?: string;
  [key: string]: any;
}

const EsignNewForm = (props?: IEsignProps) => {
  // const history = useHistory();
  const navigate = useNavigate()
  const [errCode, setErrCode] = React.useState("");
  const [authenticate, setAuthenticate] = React.useState<boolean>(false);
  const [isAuthVerified, setIsAuthVerified] = React.useState<boolean>(false);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [completionStatus, setCompletionStatus] =
    React.useState<ICompletionStatus>();
  const [values, setValues] = React.useState({
    email: "",
    mobile: "",
  });
  const [rmAssited, setRmAssited] = React.useState<boolean>(false);
  const [isElogFlow, setIsElogFrow] = React.useState<boolean>(false);
  const [firstEsignReq, setFirstEsignReq] = React.useState<boolean>(false);
  const [uccCode, setUccCode] = React.useState<string>("");
  const [radioSelection, setRadioSelection] = React.useState<boolean>(true);
  const [firstName, setFirstName] = React.useState<string>("");
  const [lastName, setLastName] = React.useState<string>("");
  const [showMobileBtn, setShowMobileBtn] = React.useState<boolean>(true);
  const [showMobileMailBtn, setShowMobileMailBtn] =
    React.useState<boolean>(true);
  const [showMobileOtp, setShowMobileOtp] = React.useState<boolean>(false);
  const [disableOtp, setDisableOtp] = React.useState<boolean>(false);
  const [isMobileVerified, setIsMobileVerified] =
    React.useState<boolean>(false);
  const [dob, setDob] = React.useState<any>();
  const [isEmailVerified, setIsEmailVerified] = React.useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = React.useState(false);
  const [invalidOtp, setInvalidOtp] = React.useState<boolean>(false);
  const [showEmailOtp, setShowEmailOtp] = React.useState<boolean>(false);
  const [disableEmailOtp, setDisableEmailOtp] = React.useState<boolean>(false);
  const [invalidEmailOtp, setInvalidEmailOtp] = React.useState<boolean>(false);
  const [mailVerifiedFE, setMailVerifiedFE] = React.useState<boolean>(false);
  const [leadDetails, setLeadDetails] = React.useState<ILeadDetails>({});
  const [mobileVerifiedFE, setMobileVerifiedFE] =
    React.useState<boolean>(false);
  const [isVerified, setIsVerified] = React.useState<{
    type: string;
    isVerify: boolean;
  }>({
    type: "MOB",
    isVerify: false,
  });
  const [errors, setErrors] = React.useState<{
    [key in keyof ILeadFormFields]?: string;
  }>({
    email: undefined,
    mobile: undefined,
  });
  const [otpIds, setOtpIds] = React.useState<{
    emailOtpId?: string;
    mobileOtpId?: string;
  }>({
    emailOtpId: undefined,
    mobileOtpId: undefined,
  });
  const [getStatusApiResponse, setGetStatusApiResponse] = React.useState<any>();
  const [externalLeadApiResponse, setExternalLeadApiResponse] = React.useState<any>();
  const [accHolders, setAccHolders] = React.useState<AccountHolder[]>([]);
  const [holderErrors, setHolderErrors] = React.useState<any>({});
  const [holderOtpStates, setHolderOtpStates] = React.useState<any>({});
  const [holderVerificationStates, setHolderVerificationStates] = React.useState<any>({});
  const [countryCode, setCountryCode] = useState("")
  const [phonePrefix, setPhonePrefix] = useState("")

  function validateOtp(otpType: "email" | "mobile", val: string, holderId?: number) {
    if (invalidOtp) {
      setInvalidOtp(false);
    }
    if (invalidEmailOtp) {
      setInvalidEmailOtp(false);
    }
    if (val.length === 4) {
      setIsLoading(true);
      if (otpType === "email") {
        setDisableEmailOtp(true);
      } else if (otpType === "mobile") {
        setDisableOtp(true);
      }
      let otpId = otpType == "email" ? otpIds?.emailOtpId : otpIds?.mobileOtpId
      if (holderId) {
        otpId = otpType === "email" ? holderOtpStates[holderId]?.emailOtpId : holderOtpStates[holderId]?.mobileOtpId
      }
      AValidateOtpNew(
        (res: any) => {
          if (otpType === "email") {
            checkEmailValidateOtpNew(res, holderId);
          } else {
            checkMobileValidateOtpNew(res, holderId);
          }
        },
        otpId,
        val
      );
    }
  }

  function checkEmailValidateOtpNew(res: any, holderId?: number) {
    setDisableEmailOtp(false);
    if (!res || res.error) {
      //setErrCode('102 - Failed to fetch existing Leads');
      // setErrCode(errorMessage.searchLead);
      setErrCode(res.error);
    } else {
      console.log(res, "works");
      if (
        res.data &&
        res?.data?.data &&
        !!res?.data?.success &&
        res?.data?.success == true
      ) {
        GlobalStore.user.email = values.email;
        if (holderId) {
          setIsLoading(true);
          setHolderVerificationStates((prev: any) => ({
            ...prev,
            [holderId]: {
              ...prev[holderId],
              emailVerified: true,
            }
          }));
          setIsLoading(false);
        }
        else if (showMobileRadio()) {
          setIsVerified((isVerified) => {
            isVerified.type = "EMAIL";
            isVerified.isVerify = true;
            return isVerified;
          });
        }
        setIsEmailVerified(true);
        setShowEmailOtp(false);
        setMailVerifiedFE(true);
      } else {
        if (showMobileRadio()) {
          setIsVerified((isVerified) => {
            isVerified.type = "EMAIL";
            isVerified.isVerify = false;
            return isVerified;
          });
        }
        setInvalidEmailOtp(true);
      }

      setErrCode("");
    }
    setIsLoading(false);
  }
  function checkMobileValidateOtpNew(res: any, holderId?: number) {
    setIsLoading(false);
    setDisableOtp(false);
    if (res.error) {
      //setErrCode('115 - Failed to validate OTP, please retry.');
      setErrCode(res.error);
    } else {
      if (
        res.data &&
        res?.data?.data &&
        !!res?.data?.success &&
        res?.data?.success == true
      ) {
        GlobalStore.user.mobile = values.mobile;
        if (holderId) {
          setIsLoading(true);
          setHolderVerificationStates((prev: any) => ({
            ...prev,
            [holderId]: {
              ...prev[holderId],
              mobileVerified: true,
            }
          }));
          setIsLoading(false);
        }
        else if (showMobileRadio()) {
          setIsVerified((isVerified) => {
            isVerified.type = "MOB";
            isVerified.isVerify = true;
            return isVerified;
          });
        }
        setIsMobileVerified(true);
        setShowMobileOtp(false);
        setMobileVerifiedFE(true);
      } else {
        if (showMobileRadio()) {
          setIsVerified((isVerified) => {
            isVerified.type = "MOB";
            isVerified.isVerify = false;
            return isVerified;
          });
        }
        setInvalidOtp(true);
      }
      setErrCode("");
    }
  }
  function onChange(key: keyof ILeadFormFields, value: string) {
    if (key === "mobile" && !integerExp.test(value)) {
      value = values[key];
    }
    setValues({ ...values, [key]: value });
    if (key === "mobile") {
      if (isMobileVerified) {
        setShowMobileBtn(false);
      } else {
        setShowMobileBtn(true);
      }
    }
    if (key === "email") {
      if (isEmailVerified) {
        setShowMobileMailBtn(false);
      } else {
        setShowMobileMailBtn(true);
      }
    }
    setErrors({ ...errors, [key]: "" });
    return value;
  }

  function sendOtp() {
    setIsLoading(true);
    //AGetMobileOtp(otpSent, values.mobile);
    if(GlobalStore.isNriOtc && gulfCountryCodes.includes(countryCode)) {
      AGetOtpNew(
        (res: any) => {
          mobileOtpSentNew(res);
        },
        values.email,
        "EMAIL"
      );
    }
    else {
    AGetOtpNew(
      (res: any) => {
        mobileOtpSentNew(res);
      },
      values.mobile,
      // GlobalStore.isNriOtc ? countryCode == '+91' ? "SMS" : "Whatsapp" : 'SMS'
      GlobalStore.isNriOtc ? "Whatsapp" : 'SMS' //temporary deployement for testing
    );
  }
  }
  function mobileOtpSentNew(res: any) {
    // console.log(res);
    if (
      res?.data?.data !== null &&
      res?.data?.data !== undefined &&
      !!res?.data?.data?.OTPId &&
      res?.data?.data?.OTPId !== ""
    ) {
      setOtpIds((otpIds) => {
        otpIds.mobileOtpId = res?.data?.data?.OTPId;
        return otpIds;
      });
      setIsLoading(false);
      setShowMobileBtn(false);
      setShowMobileOtp(true);
      setErrCode("");
    } else {
      if (res?.error) {
        setErrCode(res.error);
      } else {
        setErrCode("Failed to send OTP, please retry.");
      }
      setIsLoading(false);
      setShowMobileOtp(false);
    }
    //  else {
    //   //setErrCode('114 - Failed to send OTP, please retry.');
    //   setErrCode(res.error);
    // }
  }
  function sendEmailOtp() {
    setIsLoading(true);
    //   AGetEmailOtp((res: any) => emailOtpRes(res), emlObj);
    AGetOtpNew(
      (res: any) => {
        emailOtpResNew(res);
      },
      values.email,
      "EMAIL"
    );
  }
  function emailOtpResNew(res: any) {
    if (res.data && res.status) {
      if (
        res?.data?.data !== null &&
        res?.data?.data !== undefined &&
        !!res?.data?.data?.OTPId &&
        res?.data?.data?.OTPId !== ""
      ) {
        setOtpIds((otpIds) => {
          otpIds.emailOtpId = res?.data?.data?.OTPId;
          return otpIds;
        });
        setShowEmailOtp(true);
        setShowMobileMailBtn(false);
        setErrCode("");
      } else {
        setErrCode("Failed to send OTP, please retry.");
      }
    } else {
      // setErrCode('114 - Failed to send OTP, please retry.');
      setErrCode(res.error);
    }
    setIsLoading(false);
  }
  React.useEffect(() => {
    if (
      props?.queryParamsId
    ) {
      console.log("queryParamsId====>", props?.queryParamsId);

      setIsLoading(true);
      AGetClientDetailsByPanV1(searchByPan, props?.queryParamsId);
    }
  }, [props?.queryParamsId]);

  const splitName = (fullName = "") => {
    const parts = fullName.trim().split(" ").filter(Boolean);

    let firstName = "";
    let middleName = "";
    let lastName = "";

    if (parts.length === 1) {
      firstName = parts[0];
    } else if (parts.length === 2) {
      firstName = parts[0];
      lastName = parts[1];
    } else if (parts.length >= 3) {
      firstName = parts[0];
      lastName = parts[parts.length - 1];
      middleName = parts.slice(1, -1).join(" ");
    }

    return { firstName, middleName, lastName };
  };

  const updateJointHolders = (response: any) => {
    setAccHolders((prev) => {
      let updated = [...prev];

      if (response.firstJointHolderMobile && response.firstJointHolderEmail) {
        const { firstName, middleName, lastName } = splitName(response.firstJointHolderName || "");

        const firstHolder = {
          id: 2,
          firstName,
          middleName,
          lastName,
          pan: response.firstJointHolderPan || "",
          dob: response.firstJointHolderDOB || "",
          relation: response.firstJointHolderRelation || "",
          email: response.firstJointHolderEmail || "",
          mobile: response.firstJointHolderMobile || "",
          relationId: response.firstJointHolderRelationId || ""
        };

        const idx = updated.findIndex((h) => h.id === 2);
        if (idx !== -1) updated[idx] = { ...updated[idx], ...firstHolder };
        else updated.push(firstHolder);
      }

      // ---------- SECOND JOINT HOLDER (ID: 3) ----------
      if (response.secondJointHolderMobile && response.secondJointHolderEmail) {
        const { firstName, middleName, lastName } = splitName(response.secondJointHolderName || "");

        const secondHolder = {
          id: 3,
          firstName,
          middleName,
          lastName,
          pan: response.secondJointHolderPan || "",
          dob: response.secondJointHolderDOB || "",
          relation: response.secondJointHolderRelation || "",
          email: response.secondJointHolderEmail || "",
          mobile: response.secondJointHolderMobile || "",
          relationId: response.secondJointHolderRelationId || ""
        };

        const idx = updated.findIndex((h) => h.id === 3);
        if (idx !== -1) updated[idx] = { ...updated[idx], ...secondHolder };
        else updated.push(secondHolder);
      }
      return updated;
    });
  };

  const updateHolder = (id: any, field: any, value: any) => {
    setAccHolders(prev =>
      prev.map(h =>
        h.id === id ? { ...h, [field]: value } : h
      )
    );
    setErrCode('')
    if (field == 'email') {
      setHolderVerificationStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          emailVerified: false,
          emailTimer: 0
        },
      }));
      setHolderOtpStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          emailSent: false,
        },
      }));
    }
    if (field == 'mobile') {
      setHolderVerificationStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          mobileVerified: false,
          mobileTimer: 0
        },
      }));
      setHolderOtpStates((prev: any) => ({
        ...prev,
        [id]: {
          ...prev[id],
          mobileSent: false,
        },
      }));
    }
  };

  const holderSendEmailOTP = async (holderId: number, email: string) => {
    if (!email || !emailRegex.test(email)) {
      return;
    }

    try {
      setIsLoading(true);
      AGetOtpNew(
        (res: any) => {
          if (res?.data?.data !== null && res?.data?.data !== undefined && !!res?.data?.data?.OTPId && res?.data?.data?.OTPId !== "") {
            setHolderOtpStates((prev: any) => ({
              ...prev,
              [holderId]: {
                ...prev[holderId],
                email: email,
                emailSent: true,
                emailTimer: 15,
                emailOtpId: res?.data?.data?.OTPId,
              }
            }));
            const interval = setInterval(() => {
              setHolderOtpStates((prev: any) => {
                const currentTimer = prev[holderId]?.emailTimer || 0;
                if (currentTimer <= 1) {
                  clearInterval(interval);
                  return {
                    ...prev,
                    [holderId]: {
                      ...prev[holderId],
                      emailTimer: 0,
                    }
                  };
                }
                return {
                  ...prev,
                  [holderId]: {
                    ...prev[holderId],
                    emailTimer: currentTimer - 1,
                  }
                };
              });
            }, 1000);
            setErrCode("");
          } else {
            if (res?.error) {
              setErrCode(res.error);
            } else {
              setErrCode("Failed to send Email OTP, please retry.");
            }
          }
          setIsLoading(false);
        },
        email,
        "EMAIL"
      );
    } catch (error) {
      setIsLoading(false);
      setErrCode("Failed to send Email OTP");
    }
  };

  const holderSendMobileOTP = async (holderId: number, mobile: string) => {
    if (!mobile || !phoneNo.test(mobile) || mobile.length !== 10) {
      return;
    }
    try {
      setIsLoading(true);
      AGetOtpNew(
        (res: any) => {
          if (
            res?.data?.data !== null &&
            res?.data?.data !== undefined &&
            !!res?.data?.data?.OTPId &&
            res?.data?.data?.OTPId !== ""
          ) {
            setHolderOtpStates((prev: any) => ({
              ...prev,
              [holderId]: {
                ...prev[holderId],
                mobile: mobile,
                mobileSent: true,
                mobileTimer: 15,
                mobileOtpId: res?.data?.data?.OTPId,
              }
            }));
            const interval = setInterval(() => {
              setHolderOtpStates((prev: any) => {
                const currentTimer = prev[holderId]?.mobileTimer || 0;
                if (currentTimer <= 1) {
                  clearInterval(interval);
                  return {
                    ...prev,
                    [holderId]: {
                      ...prev[holderId],
                      mobileTimer: 0,
                    }
                  };
                }
                return {
                  ...prev,
                  [holderId]: {
                    ...prev[holderId],
                    mobileTimer: currentTimer - 1,
                  }
                };
              });
            }, 1000);

            setErrCode("");
          } else {
            if (res?.error) {
              setErrCode(res.error);
            } else {
              setErrCode("Failed to send mobile OTP, please retry.");
            }
          }
          setIsLoading(false);
        },
        mobile,
        "SMS"
      );
    } catch (error) {
      setIsLoading(false);
      setErrCode("Failed to send Email OTP");
    }
  };

  const GetLeadDetails = (leadId?: string) => {
    if (leadId !== null && leadId !== undefined && leadId !== "") {
      ALeadFetchApi(
        (res: any) => {
          if (!res || res.error) {
            // setErrCode(164)
            setErrCode(errCode + res.error);
            // gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
          } else if (res?.data) {
            if (Array?.isArray(res?.data) && res?.data?.length > 0) {
              const leadObj = res?.data[0] as ILeadDetails;
              let productObj = res?.data[0] as ILocalQueryObject;
              setExternalLeadApiResponse(productObj)
              GlobalStore.externalDetails = productObj
              GlobalStore.personaldetails.pan = leadObj.pan
              if (leadObj !== undefined) {
                setValues((values) => {
                  if (leadObj?.email !== undefined) {
                    values.email = leadObj?.email;
                  }
                  if (leadObj?.mobile !== undefined)
                    values.mobile = leadObj?.mobile;
                  return values;
                });
                setIsMobileVerified(leadObj?.isMobileVerified || false)
                setMobileVerifiedFE(leadObj?.isMobileVerified || false)
                setIsEmailVerified(leadObj?.isEmailVerified || false)
                setMailVerifiedFE(leadObj?.isEmailVerified || false)
                setPhonePrefix(leadObj?.countryprefix || '91')
                setCountryCode('+' + leadObj?.countryprefix || '+91')
                if (leadObj?.isMobileVerified && leadObj?.isEmailVerified) {
                  setIsAuthVerified(true);
                }
                updateJointHolders(leadObj)
              }
              if (
                leadObj !== undefined &&
                leadObj?.uccCode !== "" &&
                !!leadObj?.uccCode
              )
                setUccCode(leadObj?.uccCode);
              if (
                leadObj?.firstName !== null &&
                leadObj?.firstName !== undefined &&
                leadObj?.firstName !== ""
              ) {
                setFirstName(leadObj?.firstName);
              }

              if (
                leadObj?.lastName !== null &&
                leadObj?.lastName !== undefined &&
                leadObj?.lastName !== ""
              ) {
                setLastName(leadObj?.lastName);
              }
              setLeadDetails(leadObj);
            }
          }
        },
        {
          id: leadId,
          name: "",
          stageFlag: 2,
        }
      );
    }
  };

  const searchByPan = (res: any) => {
    if (!res || res.error) {
      // setErrCode("118 - Error in fetching Client details from our system.");
      setErrCode(res.error);
      // gtmService({
      //   action: "GetClientDataByPanOrLead",
      //   label: "ERROR || ERR148",
      // });
      setIsLoading(false);
    } else {
      setIsLoading(true);
      if (res.data) {
        if (res.data != null) {
          setCompletionStatus(res?.data);
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          GlobalStore.accountcategory = res.data?.AccountCategory;
          GetLeadDetails(res.data.LeadId);
          setIsLoading(true);
          AgetAMLDetails(
            (res: any) => {
              setIsLoading(false);
            },
            GlobalStore.applicationID
          );
          AGetStageCompletionStatus(
            (res: any) => getClientStageDetails(res),
            GlobalStore.applicationID
          );
        }
      } else {
        setErrCode("1182 - Error in fetching Client details from our system.");
        setIsLoading(false);
        // gtmService({
        //   action: "GetClientDataByPanOrLead",
        //   label: "ERROR || ERR148-S",
        // });
      }
    }
  };
  const convertDate = (dateString: string) => {
    // Split the input date string by "/"
    const [day, month, year] = dateString.split("/");

    // Create a new Date object with the parsed values
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month - 1 because months are zero-indexed

    // Format the date to "mm-dd-yyyy"
    const formattedDate = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;

    return formattedDate;
  };
  function getClientStageDetails(res: any) {
    setIsLoading(false);
    if (!res || res.error) {
      // setErrCode('1061 - Error in fetching stage completion details.');
      // setErrCode(errorMessage.getClientStageDetails);
      // gtmService({
      //   action: "GetStageCompletionStatus",
      //   label: "ERROR || ERR147",
      // });
      setErrCode(res.error);
    } else {
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        setGetStatusApiResponse(responseObj)
        GlobalStore.entityType = responseObj?.entitytype
        GlobalStore.entitySubType = responseObj?.entitysubtype
        GlobalStore.isOTCFlow = responseObj?.isotc
        GlobalStore.isNriOtc = responseObj.isNRI && responseObj?.isotc

        if (responseObj !== null && responseObj != undefined) {
          if (responseObj?.accountcategory == 2 && responseObj?.elog_opted && responseObj?.iskra) {
            setIsElogFrow(true)
          }
          setFirstEsignReq(responseObj?.first_esign_req)
          if (
            responseObj?.rmassisted !== null &&
            responseObj?.rmassisted !== undefined &&
            responseObj?.rmassisted
          ) {
            setRmAssited(true);
          }
          if (responseObj?.dob !== null && responseObj?.dob !== undefined) {
            // let date = moment(moment(convertDate(responseObj?.dob)).toDate())
            //   .startOf("day")
            //   .toDate();
            // setDob(moment(dob).format("yyyy-MM-DD"));
            let date = moment(responseObj?.dob, "DD/MM/YYYY").format("YYYY-MM-DD");
            setDob(date);
          }
          if (props?.setIsKRA != undefined) {
            props?.setIsKRA(true);
          }
          // if (responseObj.iskra) {
          if (props?.setIsKRA != undefined) {
            if (responseObj.first_esign_req) {
              props?.setIsKRA(false);
            } else if (GlobalStore.isOTCFlow) {
              props?.setIsKRA(true);
            } else {
              props?.setIsKRA(responseObj.iskra);
            }
            if (responseObj?.auth_ver && responseObj?.first_esign_req && responseObj?.accountcategory == 2) {
              if (responseObj.isesigncompleted && responseObj?.elog_opted) {
                // history.push(statusUrl.elogVerificationInProgress);
                navigate(statusUrl.elogVerificationInProgress)
              } else if (responseObj.isesigncompleted) {
                navigate(containerUrl.esignsubmit)
              } else {
                return
              }
            } else if (responseObj?.auth_ver && responseObj?.accountcategory == 2 && responseObj?.elog_opted) {
              // history.push(statusUrl.elogVerificationInProgress);
              navigate(statusUrl.elogVerificationInProgress)
            } else if (responseObj?.auth_ver && responseObj?.first_esign_req && responseObj.isesigncompleted) {
              // history.push(containerUrl.esignsubmit);
              navigate(containerUrl.esignsubmit)
            } else if (responseObj?.auth_ver && responseObj?.first_esign_req) {
            } else if (responseObj?.auth_ver) {
              // history.push(containerUrl.esignsubmit);
              navigate(containerUrl.esignsubmit)
            }
          }
          else {
            if (
              responseObj.isesigncompleted !== null &&
              responseObj.isesigncompleted == true &&
              responseObj?.auth_ver
            ) {
              // history.push(containerUrl.esignsubmit);
              navigate(containerUrl.esignsubmit)
            }
          }
        }
      } else {
        // gtmService({
        //   action: "GetStageCompletionStatus",
        //   label: "ERROR || ERR147-S",
        // });
      }
    }
  }
  const updateStageStatus = (isEmailVerified: boolean = false, isMobileVerified: boolean = false) => {
    let userId = "0";
    console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = tokenMainObj?.UserId?.toString();
    }
    let reaObj = {
      applicationId: completionStatus?.ApplicatoinId,
      accountCagtegory: completionStatus?.AccountCategory,
      stageOrderId: 11,
      UserId: userId,
      rmassisted: rmAssited,
    };
    AUpdateStageCompletionStatus((req: any) => {
      if (!req.status) {
        // setErrCode("118 - Error in fetching Client details from our system.");
        setErrCode(req.error);
        // gtmService({
        //   action: "GetClientDataByPanOrLead",
        //   label: "ERROR || ERR148",
        // });
        setIsLoading(false);
      } else {
        if (
          props?.isKRA !== null &&
          props?.isKRA !== undefined &&
          props?.isKRA === false
        ) {
          if (!isEmailVerified && !isMobileVerified) {
            getRMAssitedEsignLink();
          }
        }
        if (req?.data !== null && !isEmailVerified && !isMobileVerified) {
          if (props?.isKRA) {
            setIsLoading(false);
            if (isElogFlow) {
              // history.replace(statusUrl.elogVerificationInProgress);
              navigate(statusUrl.elogVerificationInProgress, { replace: true })
            } else {
              // history.replace(containerUrl.esignsubmit);
              navigate(containerUrl.esignsubmit, { replace: true })
            }
          } else {
            setIsLoading(false);
          }
        } else {
          setIsLoading(false);
        }
      }
    }, reaObj);
  };
  const handleCreateUcc = (isEmailVerified: boolean = false, isMobileVerified: boolean = false) => {
    setIsLoading(true);
    let accHolderDetails: any = sessionStorage.getItem("accHolders")
    let jointAccHolders: any = []
    if (accHolders.length > 0) {
      jointAccHolders = accHolders.map((acc, i) => {
        const fullName = `${acc.firstName ?? ""} ${acc.middleName ?? ""} ${acc.lastName ?? ""}`
          .replace(/\s+/g, " ")
          .trim();
        return {
          emailID: acc.email,
          mobileno: acc.mobile,
          panNo: acc.pan,
          dob: acc.dob,
          relationName: acc.relation,
          relationId: acc.relationId,
          panFName: acc.firstName,
          panMName: acc.middleName,
          panLName: acc.lastName,
          panFSName: fullName,
          holderId: `HOLDER${i + 1}`
        }
      })
    }
    let reqObj = {
      mobile: values.mobile,
      email: values.email,
      oldMobile: getStatusApiResponse.mobileno,
      oldEmail: getStatusApiResponse.emailid,
      leadId: GlobalStore.leadId,
      isMobileVerify: mobileVerifiedFE || isMobileVerified,
      isEmailVerify: mailVerifiedFE || isEmailVerified,
      firstName: firstName,
      lastName: lastName,
      applicationId: GlobalStore?.applicationID,
      requestStage: 1,
      leadSource: "DIY",
      isPanVerify: true,
      Pan: leadDetails?.pan,
      dob:
        dob !== null && dob !== undefined
          ? dob
          : moment(leadDetails?.dob).format("yyyy-MM-DD"),
      isConfirmedUcc:
        uccCode == "" || uccCode == undefined || uccCode == null ? false : true,
      // removing this as per discussion with sandeep on 23-01-2026
      // isGuardianPan: GlobalStore.externalDetails.isguradianpan,
      guardianPan: "",
      entityType: GlobalStore.entityType,
      entitySubType: GlobalStore.entitySubType,
      entityTypeId: GlobalStore.externalDetails.entityTypeId,
      clientTypeId: GlobalStore.externalDetails.clienttypeid,
      jointHolderDetails: jointAccHolders.length > 0 ? jointAccHolders : JSON.parse(accHolderDetails) || []
    };

    CreateUCCRegCode((req: any) => {
      if (!req.status) {
        // setErrCode("118 - Error in fetching Client details from our system.");
        setErrCode(req.error);
        // gtmService({
        //   action: "GetClientDataByPanOrLead",
        //   label: "ERROR || ERR148",
        // });
        setIsLoading(false);
      } else {
        // if (!isEmailVerified && !isMobileVerified) {
        updateStageStatus(isEmailVerified, isMobileVerified);
        // } else {
        //   setIsLoading(false);
        // }
      }
    }, reqObj);
  };
  const AEmailUpdate = () => {
    let reqObj = {
      emailId: leadDetails?.email,
      uccCode: leadDetails?.uccCode,
      source: "",
      ApplicationId: GlobalStore?.applicationID,
    };
    if (uccCode && leadDetails?.isEmailVerified == false)
      AEmailUpdateApi((req: any) => {
        if (!req || req.error) {
          // setErrCode("118 - Error in fetching Client details from our system.");
          setErrCode(req.error);
          // gtmService({
          //   action: "GetClientDataByPanOrLead",
          //   label: "ERROR || ERR148",
          // });
          setIsLoading(false);
        } else {
        }
      }, reqObj);
  };
  const checkDisableForm = () => {
    let disabledButton = false;
    if (showMobileRadio()) {
      if (isVerified?.type !== null && isMobileVerified) {
        disabledButton = false;
      } else {
        disabledButton = true;
      }
    } else if (hideEmailVerifyButton() && mobileVerifiedFE == true)
      disabledButton = false;
    else if (hideMobileVerifyButton() && mailVerifiedFE == true)
      disabledButton = false;
    else if (mailVerifiedFE == true && mobileVerifiedFE == true)
      disabledButton = false;
    else disabledButton = false;
    if (
      errCode !== null &&
      errCode !== undefined &&
      typeof errCode === "string" &&
      errCode != ""
    ) {
      disabledButton = true;
    }
    if (
      (values?.email === null ||
        values?.email === undefined ||
        values?.email === "") &&
      (values?.mobile === null ||
        values?.mobile === undefined ||
        values?.mobile === "")
    ) {
      disabledButton = true;
    }
    return disabledButton;
  };
  const generateEsignFields = () => {
    return (
      <>
        {accHolders?.length > 0 &&
          <>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <label className="inptLblTitle">
                Account Holder 1 (Primary)
              </label>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: '5px',
                fontSize: '10px'
              }}
            >
              <label>
                UCC Will be created with the Name as of 1st Holder
              </label>
            </div>
          </>
        }
        {showEmailField() && (
          <>
            <div className="email">
              <div className="row emlInput">
                <label className="inptLbl">Email ID</label>
                <InputField
                  pattern={emailRegex}
                  defaultValue={values?.email}
                  disabled={externalLeadApiResponse.isEmailVerified}
                  onChange={(value) => {
                    if (forbiddenWordsRegex.test(value)) {
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: errorMsg(errorCode.FE48),
                      });
                    } else {
                      if (hideEmailVerifyButton()) {
                      } else {
                        setShowMobileMailBtn(true);
                      }

                      setIsEmailVerified(false);
                      setIsButtonDisabled(false);

                      onChange("email", value);
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: "",
                      });
                      onChange("email", value);
                    }
                  }}
                  onBlur={(error, e) => {
                    if (
                      e?.target?.value !== undefined &&
                      e?.target?.value !== null &&
                      e?.target?.value !== "" &&
                      forbiddenWordsRegex.test(e?.target?.value)
                    ) {
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: errorMsg(errorCode.FE48),
                      });
                    } else
                      setErrors({
                        ...errors,
                        // email: error.pattern ? '' : 'Please enter valid email',
                        email: error.pattern ? "" : errorMsg(errorCode.FE03),
                      });
                  }}
                  placeholder="Eg. example@email.com"
                  errorText={errors.email}
                  type="email"
                  suffix={
                    hideEmailVerifyButton() || (values.email !== "" && isEmailVerified) || externalLeadApiResponse.isEmailVerified ? (
                      <i className="edel-icon-tick" />
                    ) : (
                      <></>
                    )
                  }
                />
              </div>
              {hideEmailVerifyButton() ? (
                <></>
              ) : (
                <>
                  {" "}
                  {showMobileMailBtn && !isEmailVerified && !externalLeadApiResponse.isEmailVerified && (
                    <div className="emlVrfy">
                      <Verify
                        btnName="Verify"
                        disabled={
                          !(
                            values?.email !== null &&
                            values !== undefined &&
                            values?.email !== ""
                          ) ||
                          (errors?.email !== undefined &&
                            errors?.email !== null &&
                            errors?.email !== "" &&
                            errors?.email?.length > 0)
                        }
                        onClick={() => {
                          // gtmService({
                          //   action: "LEAD_PAGE",
                          //   label: "MOB_VERIFY",
                          // });

                          sendEmailOtp();
                        }}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
            {showEmailOtp && !showMobileMailBtn ? (
              <div className="otpSection">
                <RegOtp
                  label="Enter Email OTP"
                  otpTimer={15}
                  eleId="eml_"
                  onChange={(val) => validateOtp("email", val)}
                  resendClicked={sendEmailOtp}
                  disableOtp={disableEmailOtp}
                  invalidOtp={invalidEmailOtp}
                />
              </div>
            ) : (
              ""
            )}
          </>
        )}
        <>
          {showMobileField() && (
            <>
              <div className="email">
                <div className="row emlInput">
                  <label className="inptLbl">Mobile No.</label>
                  {GlobalStore.isNriOtc ?
                    <MobileInput
                      onChange={(country, value) => {
                        if (hideMobileVerifyButton()) {
                        } else {
                          setShowMobileBtn(true);
                        }
                        setIsButtonDisabled(false);
                        setIsMobileVerified(false);
                        // setAllreadyExistMobOrEmail({ email: false, mob: false });
                        setCountryCode(country)
                        onChange("mobile", value);
                      }}
                      onBlur={(error, event) => {
                        if (
                          event?.target?.value !== undefined &&
                          event?.target?.value !== null &&
                          event?.target?.value !== "" &&
                          (!error?.pattern)
                        ) {
                          setErrors({
                            ...errors,
                            mobile: error.pattern ? "" : errorMsg(errorCode.FE52),
                          });
                        } else {
                          setErrors({
                            ...errors,
                            mobile: error.pattern ? "" : errorMsg(errorCode.FE04),
                          });
                        }
                      }}
                      suffix={
                        hideMobileVerifyButton() || (values.mobile !== "" && isMobileVerified) || externalLeadApiResponse.isMobileVerified ? (
                          <i className="edel-icon-tick" />
                        ) : (
                          <></>
                        )
                      }
                      placeholder="Eg. 9876543210"
                      errorText={errors.mobile}
                      required={true}
                      defaultCountry="in"
                      enableSearch={true}
                      value={values.mobile}
                      defaultPhoneNumber={values.mobile}
                      defaultDialCode={phonePrefix}
                      disabled={externalLeadApiResponse.isMobileVerified}
                      disableDropdown={externalLeadApiResponse.isMobileVerified}
                    />
                    :
                  <InputField
                    pattern={phoneNo}
                    disabled={externalLeadApiResponse.isMobileVerified}
                    defaultValue={values?.mobile}
                    onChange={(value) => {
                      if (hideMobileVerifyButton()) {
                      } else {
                        setShowMobileBtn(true);
                      }

                      setIsButtonDisabled(false);
                      setIsMobileVerified(false);
                      // setAllreadyExistMobOrEmail({ email: false, mob: false });
                      onChange("mobile", value);
                    }}
                    onBlur={(error) =>
                      setErrors({
                        ...errors,
                        // mobile: error.pattern ? '' : 'Please enter valid phone number',
                        mobile: error.pattern ? "" : errorMsg(errorCode.FE04),
                      })
                    }
                    placeholder="Eg. 9876543210"
                    errorText={errors.mobile}
                    type="tel"
                    inputPattern={integerExp}
                    suffix={
                      hideMobileVerifyButton() || (values.mobile !== "" && isMobileVerified) || externalLeadApiResponse.isMobileVerified ? (
                        <i className="edel-icon-tick" />
                      ) : (
                        <></>
                      )
                    }
                    maxLength={10}
                    onKeyPress={(
                      keyEvent: React.KeyboardEvent<HTMLInputElement>
                    ) => {
                      if (keyEvent.key >= "0" && keyEvent.key <= "9") {
                        return true;
                      } else {
                        if (
                          keyEvent.key !== "Backspace" &&
                          keyEvent.key !== "Enter"
                        )
                          keyEvent.preventDefault();
                      }
                    }}
                  />
                  }
                </div>
                {hideMobileVerifyButton() ? (
                  <></>
                ) : (
                  showMobileBtn &&
                  !isMobileVerified && !externalLeadApiResponse.isMobileVerified && (
                    <div className="emlVrfy">
                      <Verify
                        btnName="Verify"
                        disabled={(GlobalStore.isNriOtc && gulfCountryCodes.includes(countryCode) && !isEmailVerified) ? true :
                          Object.values([errors.mobile]).some(
                            (error) => error
                          ) ||
                          Object.values([values.mobile]).some((value) => !value)
                        }
                        onClick={() => {
                          // gtmService({ action: "LEAD_PAGE", label: "MOB_VERIFY" });
                          sendOtp();
                        }}
                      />
                    </div>
                  )
                )}
              </div>
              {GlobalStore.isNriOtc &&
                <label className='emailInfoMsg'>
                  For gulf countries, otp will be shared on above mentioned email after verification.
                </label>
              }
              {showMobileOtp && !showMobileBtn && (
                <div className="otpSection">
                  <RegOtp
                    label="Enter Mobile OTP"
                    otpTimer={15}
                    eleId="mob_"
                    onChange={(val) => validateOtp("mobile", val)}
                    resendClicked={() => {
                      // gtmService({ action: "LEAD_PAGE", label: "OTP_RESEND" });
                      sendOtp();
                    }}
                    disableOtp={disableOtp}
                    invalidOtp={invalidOtp}
                  />
                </div>
              )}
            </>
          )}
        </>
      </>
    );
  };
  const getRMAssitedEsignLink = () => {
    //redirect to NSDL website for esign
    setIsLoading(true);
    let userId = 0;
    console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    window.alert("You will be redirected here after Completion of Esign");
    AGetRMEsignUrlDetails(
      getEsignUrl,
      GlobalStore.applicationID,
      1,
      GlobalStore.accountcategory ? GlobalStore?.accountcategory : 0,
      userId
    );
  };
  const esignCleverTapEvent = (isEsign: boolean) => {
    const data = {
      EventName: cleverTapEvents.registration.eSignPage.CLICK_ON_ESIGN,
      InitiationPlatform: "",
      // UTM_SOURCE,
      // UTM_MEDIUM,
      // UTM_CAMPAIGN,
      KRA: GlobalStore.isKRA,
      DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
      ADHAR_LINKED_WITH_MOBILE: GlobalStore.aadharLinkedChoice,
      LEAD_ID: GlobalStore.leadId,
      REF_ID: GlobalStore.applicationID,
      IS_ESIGN: isEsign,
    };

    ClevertapService.pushEvent(data);

    // Apps flyer event for click on proceed on bank details page
    AppsFlyerService.pushEvent(
      appsFlyerEvents.registration.eSignPage.CLICK_ON_ESIGN
    );
  };
  function getEsignUrl(res: any) {
    if (!res || res.error) {
      console.log(res.errMsg);
      setErrCode(res.error);
      gtmService({ action: "GetEsignLink", label: "ERROR || ERR117" });
      setIsLoading(false);
    } else {
      if (
        (res.data.Code == 200 || res.data.Code == 201) &&
        res.data.Data.EsignLink !== null
      ) {
        const encryptedUrl = res.data.Data.EsignLink;
        //     gtmService({ action: "E_SIGN | E_SIGN", label: "Step_Complete" });

        // Clevertap event while user choose for e-sign
        esignCleverTapEvent(true);
        // Clevertap ends

        const eSignCall = {
          applicationId: GlobalStore.applicationID,
          isESignSubmitted: true,
        };

        localStorage.setItem(
          "isESignSubmitted",
          btoa(JSON.stringify(eSignCall))
        );

        window.location.href = encryptedUrl;
      } else {
        var allErrorsString = "";
        if (res.data.Data.FormValidationSummary.length > 0) {
          res.data.Data.FormValidationSummary.forEach(
            (element: any, i: number) => {
              if (i === 0) allErrorsString = element.FormValidations;
              else allErrorsString += `, ${element.FormValidations}`;
            }
          );
        }
        console.log("Error from Esign api", allErrorsString);
        setErrCode(res.data.Data.FormValidationSummary[0].FormValidations);
        setIsLoading(false);
      }
    }
  }
  const handleSubmit = () => {
    if (isAuthVerified) {
      handleCreateUcc();
      return;
    }

    const primaryVerified =
      (isEmailVerified || externalLeadApiResponse?.isEmailVerified) &&
      (isMobileVerified || externalLeadApiResponse?.isMobileVerified);

    if (!primaryVerified) {
      setErrCode("Please verify Email and Mobile for Account Holder");
      return;
    }

    if (accHolders && accHolders.length > 0) {
      const allJointVerified = accHolders.every(
        (holder: any, index: number) => {
          const localState = holderVerificationStates?.[holder.id];
          const apiState =
            externalLeadApiResponse?.jointHolderOtpDetails?.[index];

          const emailVerified =
            localState?.emailVerified || apiState?.isEmailVerified;

          const mobileVerified =
            localState?.mobileVerified || apiState?.isMobileVerified;

          return emailVerified && mobileVerified;
        }
      );

      if (!allJointVerified) {
        setErrCode(
          "Please verify Email and Mobile for all Account Holders"
        );
        return;
      }
    }

    handleCreateUcc();
  };

  const showMobileField = () => {
    let showMobile: boolean = false;
    if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      leadDetails?.uccCode !== null &&
      leadDetails?.uccCode !== undefined &&
      leadDetails?.uccCode !== "" &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified &&
      isVerified?.type == "MOB"
    ) {
      showMobile = true;
    } else if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      leadDetails?.uccCode !== null &&
      leadDetails?.uccCode !== undefined &&
      leadDetails?.uccCode !== "" &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified == false &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified
    ) {
      showMobile = true;
    } else if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      (leadDetails?.uccCode === null ||
        leadDetails?.uccCode === undefined ||
        leadDetails?.uccCode == "") &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified == false
    ) {
      showMobile = true;
    } else if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      (leadDetails?.uccCode === null ||
        leadDetails?.uccCode === undefined ||
        leadDetails?.uccCode === "") &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified == false &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified == false
    ) {
      showMobile = true;
    }

    return showMobile;
  };
  const showEmailField = () => {
    let showEmail: boolean = false;
    if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      leadDetails?.uccCode !== null &&
      leadDetails?.uccCode !== undefined &&
      leadDetails?.uccCode !== "" &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified &&
      isVerified?.type == "EMAIL"
    ) {
      showEmail = true;
    } else if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      leadDetails?.uccCode !== null &&
      leadDetails?.uccCode !== undefined &&
      leadDetails?.uccCode !== "" &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified == false &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified
    ) {
      showEmail = true;
    } else if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      (leadDetails?.uccCode === null ||
        leadDetails?.uccCode === undefined ||
        leadDetails?.uccCode == "") &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified == false
    ) {
      showEmail = true;
    } else if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      (leadDetails?.uccCode === null ||
        leadDetails?.uccCode === undefined ||
        leadDetails?.uccCode === "") &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified == false &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified == false
    ) {
      showEmail = true;
    }

    return showEmail;
  };
  const hideMobileVerifyButton = () => {
    let hideMpbileVerify: boolean = false;
    if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      leadDetails?.uccCode !== null &&
      leadDetails?.uccCode !== undefined &&
      leadDetails?.uccCode !== "" &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified == false &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified
    ) {
      hideMpbileVerify = true;
    }
    return hideMpbileVerify;
  };
  const hideEmailVerifyButton = () => {
    let hideEmaileVerify: boolean = false;
    if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      (leadDetails?.uccCode === null ||
        leadDetails?.uccCode === undefined ||
        leadDetails?.uccCode == "") &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified == false
    ) {
      hideEmaileVerify = true;
    }
    return hideEmaileVerify;
  };
  const showMobileRadio = () => {
    let showRadio = false;
    if (
      leadDetails !== null &&
      leadDetails !== undefined &&
      leadDetails?.uccCode !== null &&
      leadDetails?.uccCode !== undefined &&
      leadDetails?.uccCode !== "" &&
      leadDetails?.isEmailVerified !== null &&
      leadDetails?.isEmailVerified !== undefined &&
      leadDetails?.isEmailVerified &&
      leadDetails?.isMobileVerified !== null &&
      leadDetails?.isMobileVerified !== undefined &&
      leadDetails?.isMobileVerified
    ) {
      showRadio = true;
    }

    return showRadio;
  };

  return (
    <>
      <div className={"esignNewForm" + (isLoading ? " op05" : "")}>
        <div className="clientStepsInfo">
          {getStatusApiResponse?.entitysubtype == "Joint" ?
            <>
              <div className="div-contents">
                <span className="tick-background" style={{ marginBottom: "20px" }}>
                  <i className="edel-icon-tick" />
                </span>
              </div>
              <div className="div-contents">
                <label className="text-content" style={{ fontWeight: "bold", marginBottom: "20px" }}>
                  Investment Account application has been successfully reviewed and approved by our Quality Screening Team.
                </label>
              </div>
              <div className="div-contents">
                <label className="text-content" >
                  To proceed with setting up your Investment Account, please provide your final consent by verifying the OTP sent to your registered contact details
                </label>
              </div>
            </>
            :
            <div className="div-contents">
              <span className="tick-background">
                <i className="edel-icon-tick" />
              </span>
              <label className="text-content">
                {!props?.isKRA && !(mobileVerifiedFE && mailVerifiedFE) && (
                  <>Great! Your documents are ready to be E-Signed. Proceed to E-Sign by clicking the ‘verify and proceed to E-sign’ button.</>
                )}
                {((props?.isKRA) || (mobileVerifiedFE && mailVerifiedFE)) && (
                  <>Great, you have completed all the steps. Download the form and authenticate your application by entering an OTP.</>
                )}
              </label>
            </div>
          }
          {!props?.isKRA && mobileVerifiedFE && mailVerifiedFE && (
            <div className="button-section">
              <TransparentButton
                btnName="Download Form"
                onClick={() => {
                  downloadForm(
                    `Esign_${GlobalStore.applicationID}`,
                    (resp: any) => {
                      setIsLoading(resp);
                    },
                    () => { },
                    false,
                    true,
                    GlobalStore?.accountcategory
                  );
                }}
              />
            </div>
          )}
          {!props?.isKRA && authenticate && (
            <div className="button-section">
              <TransparentButton
                btnName="Download Form"
                onClick={() => {
                  downloadForm(
                    `EsignPoa_${GlobalStore.applicationID}`,
                    (resp: any) => {
                      setIsLoading(resp);
                    },
                    () => { },
                    false,
                    true,
                    GlobalStore?.accountcategory
                  );
                }}
              />
            </div>
          )}
          {props?.isKRA && (
            <div className="button-section">
              <TransparentButton
                btnName="Download Form"
                onClick={() => {
                  downloadForm(
                    `EsignPoa_${GlobalStore.applicationID}`,
                    (resp: any) => {
                      setIsLoading(resp);
                    },
                    () => { },
                    false,
                    true,
                    GlobalStore?.accountcategory
                  );
                }}
              />
            </div>
          )}
        </div>
        {!props?.isKRA && (
          <>
            {showMobileRadio() && (
              <div className="dematFormRadioSelection">
                <Radio
                  checked={radioSelection}
                  className=""
                  onChange={() => {
                    setRadioSelection(true);
                    setIsVerified((isVerified) => {
                      isVerified.type = "MOB";
                      isVerified.isVerify = false;
                      return isVerified;
                    });
                  }}
                  name="radioSelection"
                  label="Mobile Number"
                //disabled={true}
                />
                <Radio
                  className="mgl10"
                  checked={!radioSelection}
                  onChange={() => {
                    setRadioSelection(false);
                    setIsVerified((isVerified) => {
                      isVerified.type = "EMAIL";
                      isVerified.isVerify = false;
                      return isVerified;
                    });
                  }}
                  name="radioSelection"
                  label="Email ID"
                //disabled={true}
                />
              </div>
            )}

            {generateEsignFields()}
          </>
        )}
        {props?.isKRA && authenticate && (
          <>
            {showMobileRadio() && (
              <div className="dematFormRadioSelection">
                <Radio
                  checked={radioSelection}
                  className=""
                  onChange={() => {
                    setRadioSelection(true);
                    setIsButtonDisabled(false);
                    setIsMobileVerified(false);
                    setShowMobileBtn(true);
                    setMobileVerifiedFE(false);
                    setIsVerified((isVerified) => {
                      isVerified.type = "MOB";
                      isVerified.isVerify = false;
                      return isVerified;
                    });
                  }}
                  name="radioSelection"
                  label="Mobile Number"
                //disabled={true}
                />
                <Radio
                  className="mgl10"
                  checked={!radioSelection}
                  onChange={() => {
                    setRadioSelection(false);
                    setIsButtonDisabled(false);
                    setIsEmailVerified(false);
                    setShowMobileMailBtn(true);
                    setMailVerifiedFE(false);
                    setIsVerified((isVerified) => {
                      isVerified.type = "EMAIL";
                      isVerified.isVerify = false;
                      return isVerified;
                    });
                  }}
                  name="radioSelection"
                  label="Email ID"
                //disabled={true}
                />
              </div>
            )}

            {generateEsignFields()}
            {accHolders.map((holder: any, index: number) => (
              <>
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <label className="inptLblTitle">
                    Account Holder {holder.id}
                  </label>
                </div>

                {/* Email Section */}
                <div className="email">
                  <div className="row emlInput">
                    <label className="inptLbl">Email ID</label>
                    <InputField
                      pattern={emailRegex}
                      onChange={(value) => {
                        updateHolder(holder.id, "email", value)
                      }}
                      onBlur={(error, e) => {
                        const email = holder.email;
                        if (!emailRegex.test(email)) {
                          setHolderErrors((prev: any) => ({
                            ...prev,
                            [holder.id]: {
                              ...prev[holder.id],
                              email: "Invalid email format",
                            },
                          }));
                        } else {
                          setHolderErrors((prev: any) => ({
                            ...prev,
                            [holder.id]: { ...prev[holder.id], email: "" },
                          }));
                        }
                      }}
                      placeholder="Eg. example@email.com"
                      errorText={holderErrors[holder.id]?.email}
                      type="email"
                      defaultValue={holder.email}
                      suffix={
                        (holderVerificationStates[holder.id]?.emailVerified || externalLeadApiResponse?.jointHolderOtpDetails[index]?.isEmailVerified) ? (
                          <i className="edel-icon-tick" />
                        ) : (
                          <></>
                        )
                      }
                      helpText={""}
                      helpTextColor="grey"
                      disabled={externalLeadApiResponse?.jointHolderOtpDetails[index]?.isEmailVerified}
                    />
                  </div>
                  {((!holderOtpStates[holder.id]?.emailSent && !holderVerificationStates[holder.id]?.emailVerified) && !externalLeadApiResponse?.jointHolderOtpDetails[index]?.isEmailVerified) &&
                    <div className="emlVrfy">
                      <Verify
                        btnName={
                          holderOtpStates[holder.id]?.emailSent
                            ? "Resend OTP"
                            : "Verify"
                        }
                        disabled={
                          !holder.email ||
                          holderErrors[holder.id]?.email ||
                          holderOtpStates[holder.id]?.emailTimer > 0 ||
                          holderVerificationStates[holder.id]?.emailVerified ||
                          externalLeadApiResponse?.jointHolderOtpDetails[index]?.isEmailVerified
                        }
                        onClick={() => {
                          holderSendEmailOTP(holder.id, holder.email);
                          gtmService({
                            action: "JOINT_ACCOUNT",
                            label: `EMAIL_VERIFY_HOLDER_${holder.id}`,
                          });
                        }}
                      />
                    </div>
                  }
                </div>

                {/* Email OTP Section */}
                {holderOtpStates[holder.id]?.emailSent &&
                  !holderVerificationStates[holder.id]?.emailVerified && (
                    <div className="otpSection">
                      <RegOtp
                        label="Enter Email OTP"
                        otpTimer={15}
                        eleId={`email_otp_${holder.id}_`}
                        onChange={(val) => validateOtp('email', val, holder.id)}
                        resendClicked={() => {
                          holderSendEmailOTP(holder.id, holder.email);
                          gtmService({
                            action: "JOINT_ACCOUNT",
                            label: `EMAIL_OTP_RESEND_HOLDER_${holder.id}`
                          });
                        }}
                        disableOtp={false}
                        invalidOtp={invalidEmailOtp}
                      />
                    </div>
                  )}

                {/* Mobile Section */}
                <div className="email">
                  <div className="row emlInput">
                    <label className="inptLbl">Mobile No</label>
                    <InputField
                      pattern={phoneNo}
                      onChange={(value) => {
                        const cleanedValue = value.replace(/\D/g, "");
                        updateHolder(holder.id, "mobile", cleanedValue);
                        setHolderErrors((prev: any) => ({
                          ...prev,
                          [holder.id]: { ...prev[holder.id], mobile: "" },
                        }));
                      }}
                      onBlur={(error, e) => {
                        const mobile = holder.mobile?.trim();
                        if (!mobile || mobile.length !== 10 || !phoneNo.test(mobile)) {
                          setHolderErrors((prev: any) => ({
                            ...prev,
                            [holder.id]: { ...prev[holder.id], mobile: "Invalid mobile number" },
                          }));
                          return;
                        }
                        setHolderErrors((prev: any) => ({
                          ...prev,
                          [holder.id]: { ...prev[holder.id], mobile: "" },
                        }));
                      }}
                      placeholder="Eg. 9876543210"
                      errorText={holderErrors[holder.id]?.mobile}
                      type="tel"
                      defaultValue={holder.mobile}
                      suffix={
                        (holderVerificationStates[holder.id]?.mobileVerified || externalLeadApiResponse?.jointHolderOtpDetails[index]?.isMobileVerified) ? (
                          <i className="edel-icon-tick" />
                        ) : (
                          <></>
                        )
                      }
                      helpText={""}
                      helpTextColor="grey"
                      maxLength={10}
                      disabled={externalLeadApiResponse?.jointHolderOtpDetails[index]?.isMobileVerified}
                    />
                  </div>
                  {((!holderOtpStates[holder.id]?.mobileSent && !holderVerificationStates[holder.id]?.mobileVerified) && !externalLeadApiResponse?.jointHolderOtpDetails[index]?.isMobileVerified) &&
                    <div className="emlVrfy">
                      <Verify
                        btnName={
                          holderOtpStates[holder.id]?.mobileTimer > 0 && !holderVerificationStates[holder.id]?.mobileVerified
                            ? `Resend (${holderOtpStates[holder.id]?.mobileTimer}s)`
                            : holderOtpStates[holder.id]?.mobileSent
                              ? "Resend OTP"
                              : "Verify"
                        }
                        disabled={
                          !holder.mobile ||
                          holder.mobile.length !== 10 ||
                          holderErrors[holder.id]?.mobile ||
                          holderOtpStates[holder.id]?.mobileTimer > 0 ||
                          holderVerificationStates[holder.id]?.mobileVerified ||
                          externalLeadApiResponse?.jointHolderOtpDetails[index]?.isMobileVerified
                        }
                        onClick={() => {
                          holderSendMobileOTP(holder.id, holder.mobile);
                          gtmService({
                            action: "JOINT_ACCOUNT",
                            label: `MOBILE_VERIFY_HOLDER_${holder.id}`,
                          });
                        }}
                      />
                    </div>
                  }
                </div>

                {/* Mobile OTP Section */}
                {holderOtpStates[holder.id]?.mobileSent &&
                  !holderVerificationStates[holder.id]?.mobileVerified && (
                    <div className="otpSection">
                      <RegOtp
                        label="Enter Mobile OTP"
                        otpTimer={15}
                        eleId={`mobile_otp_${holder.id}_`}
                        onChange={(val) => validateOtp('mobile', val, holder.id)}
                        resendClicked={() => {
                          holderSendMobileOTP(holder.id, holder.mobile);
                          gtmService({
                            action: "JOINT_ACCOUNT",
                            label: `MOBILE_OTP_RESEND_HOLDER_${holder.id}`
                          });
                        }}
                        disableOtp={false}
                        invalidOtp={invalidOtp}
                      />
                    </div>
                  )}
              </>
            ))}
          </>
        )}

        {errCode && (
          <div className="errMsgBlck">
            <ErrMsg>
              {typeof errCode === "number" ? (
                <>
                  <label>We are facing some technical issue.</label>
                  <label>
                    Please try after sometime (error code:{errCode})
                  </label>
                </>
              ) : (
                <label>{errCode}</label>
              )}
            </ErrMsg>
          </div>
        )}
        <div className="proceed-Button-section">
          {props?.isKRA && !authenticate && (
            <SubmitButton
              // isLoading={isLoading}
              btnName="Proceed To Authenticate"
              disabled={false}
              onClick={() => {
                setAuthenticate(true);
              }}
              type="submit"
            />
          )}
          {props?.isKRA && authenticate && (
            <SubmitButton
              isLoading={isLoading}
              btnName={"Submit"}
              disabled={isLoading}
              onClick={() => {
                //
                handleSubmit();
              }}
              type="submit"
            />
          )}
          {!props?.isKRA && isAuthVerified && (
            <SubmitButton
              isLoading={isLoading}
              btnName="Proceed To Esign"
              disabled={isLoading || checkDisableForm()}
              onClick={() => {
                handleSubmit();
              }}
              type="submit"
            />
          )}
          {!props?.isKRA && !isAuthVerified && (
            <SubmitButton
              isLoading={isLoading}
              btnName="Submit"
              disabled={isLoading || checkDisableForm()}
              onClick={() => {
                setIsAuthVerified(true);
                handleCreateUcc(isEmailVerified, isMobileVerified);
              }}
              type="submit"
            />
          )}
        </div>
      </div>
    </>
  );
};
export default EsignNewForm;
